/**
 * Fab — Floating Action Button estendido CROSS.
 *
 * Posição fixa no canto inferior direito, gradiente de marca.
 * Acessível: é um <button> real com aria-label explícito.
 * Reduced-motion: transições CSS respeitam prefers-reduced-motion via tokens.
 */

interface FabProps {
  readonly label: string;
  readonly icon: string; // nome do Material Symbol
  readonly onClick: () => void;
}

export function Fab({ label, icon, onClick }: FabProps): JSX.Element {
  return (
    <button type="button" className="radar-fab" aria-label={label} onClick={onClick}>
      <span
        className="material-symbols-rounded radar-fab-icon"
        aria-hidden="true"
        style={{ fontVariationSettings: "'FILL' 1,'wght' 600,'GRAD' 0,'opsz' 24" }}
      >
        {icon}
      </span>
      <span className="radar-fab-label">{label}</span>
    </button>
  );
}
